import { render, staticRenderFns } from "./AgreementsServices.vue?vue&type=template&id=1ed09cc4&"
import script from "./AgreementsServices.vue?vue&type=script&lang=js&"
export * from "./AgreementsServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports